import type { ReactNode } from 'react';
import { ErrorState, LoadingState } from '../../components/ui/States';
import { useBrandWorkspaceV2 } from './useBrandFlags';

/** What a failed flag read says (the ErrorState's Try again reads it again). */
export const BRAND_ROUTE_ERROR_TEXT = "We couldn't load this page. Check your connection and try again.";

/**
 * Chooses today's page or its Brand Workspace v2 page by the install's flag (web.md §2.1, §2.15):
 * - flag off, or a 404 from an API older than the flag: `v1`, today's page untouched;
 * - flag on: `v2`;
 * - not known yet: a loading state;
 * - the read failed: an error with Try again. It never guesses: the old pages write brand text that is
 *   read-only while the flag is on, and the new ones need routes that answer 404 while it is off.
 */
export function BrandRoute({ v1, v2 }: { v1: ReactNode; v2: ReactNode }) {
  const flag = useBrandWorkspaceV2();
  if (flag.enabled === true) return <>{v2}</>;
  if (flag.enabled === false) return <>{v1}</>;
  if (flag.isError) return <ErrorState message={BRAND_ROUTE_ERROR_TEXT} onRetry={flag.refetch} />;
  return <LoadingState />;
}
